var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardvaloresprotagonismo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.94,251.08c-92.24-53.26-241.32-53.26-333,0S-8.2,390.69,84.05,444s241.33,53.27,333,0S508.2,304.34,415.94,251.08Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.81,341.35c6.53-3.77,17.1-3.77,23.6,0s6.46,9.9-.08,13.68-17.1,3.77-23.6,0S32.27,345.13,38.81,341.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.55,397.13c-18.27-10.54-47.78-10.54-65.93,0s-18.05,27.65.21,38.19,47.79,10.55,65.93,0S395.81,407.68,377.55,397.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.59,317.14c6.86-4,17.94-4,24.76,0s6.77,10.38-.08,14.34-17.95,4-24.76,0S424.73,321.1,431.59,317.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.15,247.43l-13.55-7.81a13.69,13.69,0,0,0-13.69,0l-75.17,43.57-6.63-3.82L140.7,311.21l6.28,3.61L58,366.2a4.56,4.56,0,0,0,0,7.91L71.69,382a13.71,13.71,0,0,0,13.71,0l88.92-51.43,10.4,6a27.39,27.39,0,0,0,27.37,0l32-18.46a6.09,6.09,0,0,0,0-10.55l-15-8.62,12.63-7.33,4.37-2.54,58.1-33.71A4.57,4.57,0,0,0,304.15,247.43Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "380.24 111.65 383.23 109.91 414.8 128.07 414.8 131.52 380.24 111.65",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.24 111.65 380.24 111.65 380.24 111.65 414.8 131.52 414.8 135.47 380.24 115.61 380.24 111.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.52,
    y: 101.66,
    height: 39.86,
    transform: "translate(93.92 405.55) rotate(-60.09)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.07 133.39 421.06 131.65 452.63 149.81 452.63 153.26 418.07 133.39",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.07 133.39 418.07 133.39 418.07 133.39 452.63 153.26 452.63 157.21 418.07 137.35 418.07 133.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.35,
    y: 123.4,
    height: 39.86,
    transform: "translate(94.05 449.25) rotate(-60.09)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.99 58.52 290.98 56.78 322.55 74.94 322.55 78.39 287.99 58.52",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.99 58.52 287.99 58.52 287.99 58.52 322.55 78.39 322.55 82.34 287.99 62.48 287.99 58.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.27,
    y: 48.53,
    height: 39.86,
    transform: "translate(93.72 298.94) rotate(-60.09)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.82 80.26 328.81 78.53 360.38 96.68 360.38 100.14 325.82 80.26",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.82 80.26 325.82 80.26 325.82 80.26 360.38 100.14 360.38 104.08 325.82 84.22 325.82 80.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.1,
    y: 70.27,
    height: 39.86,
    transform: "translate(93.85 342.64) rotate(-60.09)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.41 78.47 383.4 76.73 383.22 183.26 380.24 185 380.41 78.47",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.24 185 383.22 183.26 417.61 203 414.62 204.74 380.24 185",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,72.54l41.25,23.7-.19,114.43L376.79,187Zm37.63,132.19.18-106.52L380.41,78.47,380.24,185l34.38,19.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.99 72.54 379.97 70.8 421.23 94.51 418.24 96.24 376.99 72.54",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.24 96.24 421.23 94.51 421.03 208.93 418.05 210.67 418.24 96.24",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.24 100.21 421.23 98.48 421.06 205 418.07 206.74 418.24 100.21",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.07 206.74 421.06 205 455.44 224.74 452.45 226.48 418.07 206.74",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.82,94.28,456.08,118l-.2,114.42L414.62,208.7Zm37.63,132.2L452.63,120l-34.39-19.74-.17,106.53,34.38,19.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.82 94.28 417.81 92.54 459.06 116.25 456.08 117.98 414.82 94.28",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.08 117.98 459.06 116.25 458.87 230.67 455.88 232.41 456.08 117.98",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.16 25.34 291.15 23.61 290.97 130.13 287.99 131.87 288.16 25.34",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.99 131.87 290.97 130.13 325.36 149.87 322.37 151.6 287.99 131.87",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.74,19.41,326,43.12l-.19,114.42-41.26-23.71Zm37.63,132.2.18-106.53L288.16,25.34,288,131.87l34.38,19.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.74 19.41 287.72 17.67 328.98 41.38 325.99 43.12 284.74 19.41",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.99 43.12 328.98 41.38 328.78 155.8 325.8 157.54 325.99 43.12",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.99 47.08 328.98 45.35 328.81 151.87 325.82 153.61 325.99 47.08",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.82 153.61 328.81 151.87 363.19 171.61 360.2 173.35 325.82 153.61",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.57,41.15l41.26,23.71-.2,114.42-41.26-23.71Zm37.63,132.2.18-106.53L326,47.08l-.17,106.53,34.38,19.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.57 41.15 325.56 39.41 366.81 63.12 363.83 64.86 322.57 41.15",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.83 64.86 366.81 63.12 366.62 177.54 363.63 179.28 363.83 64.86",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.74,319.63l15.83.46,15.83-.46c.68,10.69-1.4,21.59-4.28,26.91h0A7.23,7.23,0,0,1,59,349.73c-4.67,2.7-12.22,2.7-16.86,0A7.08,7.08,0,0,1,39,346.46C36.12,341.11,34.06,330.27,34.74,319.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.41,313.14c-6.2,3.59-6.24,9.39-.07,13s16.18,3.59,22.39,0,6.23-9.38.07-13S45.61,309.56,39.41,313.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.86,314.57c-4.84,2.79-4.86,7.32,0,10.12s12.63,2.79,17.46,0,4.87-7.33.06-10.12S46.7,311.78,41.86,314.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.86,314.57c-4.84,2.79-4.86,7.32,0,10.12s12.63,2.79,17.46,0,4.87-7.33.06-10.12S46.7,311.78,41.86,314.57Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M24.54,252.07c35.68,11.68,36,35.55,28,52.55-2,3.44-8.17,5.29-13.51-15.85l9.37,1.2-10.92-5.54L34.6,276l9.1.68-11.55-4.86A170.39,170.39,0,0,0,24.54,252.07Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.54,252.07c35.68,11.68,36,35.55,28,52.55-2,3.44-8.17,5.29-13.51-15.85l9.37,1.2-10.92-5.54L34.6,276l9.1.68-11.55-4.86A170.39,170.39,0,0,0,24.54,252.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.54,252.07c35.68,11.68,36,35.55,28,52.55-2,3.44-8.17,5.29-13.51-15.85l9.37,1.2-10.92-5.54L34.6,276l9.1.68-11.55-4.86A170.39,170.39,0,0,0,24.54,252.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.63,258c18.81,14.28,20.51,30.65,15.2,47.74C51.71,290.73,53.74,275.51,34.63,258Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,276.31c-35.17,5-39.44,27.13-34.77,44.3,1.32,3.54,6.73,6.28,15.22-12.52l-8.93-.44,11.09-3.34,4-7.42L63,296l11.57-2.6A163.18,163.18,0,0,1,85,276.31Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,276.31c-35.17,5-39.44,27.13-34.77,44.3,1.32,3.54,6.73,6.28,15.22-12.52l-8.93-.44,11.09-3.34,4-7.42L63,296l11.57-2.6A163.18,163.18,0,0,1,85,276.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,276.31c-35.17,5-39.44,27.13-34.77,44.3,1.32,3.54,6.73,6.28,15.22-12.52l-8.93-.44,11.09-3.34,4-7.42L63,296l11.57-2.6A163.18,163.18,0,0,1,85,276.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.58,280.2c-19.9,10.17-24.2,25.14-22.09,41.94C53.24,307.81,53.88,293.3,74.58,280.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.24,284.62c32.26.53,38.59,20,36.3,36-.79,3.34-5.36,6.41-15.12-9.58l8-1.4-10.37-1.77-4.48-6.24,7.64-1.75-10.72-1.06A146,146,0,0,0,14.24,284.62Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,287c19.07,6.94,24.63,20,24.61,35.33C46.37,309.46,44.17,296.45,24,287Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.24,284.62c32.26.53,38.59,20,36.3,36-.79,3.34-5.36,6.41-15.12-9.58l8-1.4-10.37-1.77-4.48-6.24,7.64-1.75-10.72-1.06A146,146,0,0,0,14.24,284.62Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.32,294.35l16.61.49,16.6-.49c.72,11.22-1.47,22.64-4.49,28.23h0a7.56,7.56,0,0,1-3.29,3.35c-4.9,2.83-12.82,2.83-17.68,0a7.38,7.38,0,0,1-3.29-3.43C428.78,316.88,426.61,305.51,427.32,294.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.23,287.55c-6.51,3.76-6.54,9.85-.08,13.6s17,3.76,23.48,0,6.54-9.84.08-13.6S438.73,283.8,432.23,287.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.8,289.05c-5.08,2.93-5.1,7.68-.06,10.61s13.24,2.93,18.32,0,5.1-7.68.06-10.61S439.87,286.12,434.8,289.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M434.8,289.05c-5.08,2.93-5.1,7.68-.06,10.61s13.24,2.93,18.32,0,5.1-7.68.06-10.61S439.87,286.12,434.8,289.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M452.4,260.37c2.7-3.35,5.83-6.36,8.31-9.89,1.69-2.4,3.1-5.35,2.39-8.2a7.35,7.35,0,0,0-5.81-5.12,11.11,11.11,0,0,0-7.8,1.75,24,24,0,0,0-5.9,5.61,58.59,58.59,0,0,0-12.34,41.84,8.76,8.76,0,0,0,1.54,4.81,4.81,4.81,0,0,0,5,1.51c4.53-1.34,3.93-7.45,4.67-11a50,50,0,0,1,10-21.27Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.4,260.37c2.7-3.35,5.83-6.36,8.31-9.89,1.69-2.4,3.1-5.35,2.39-8.2a7.35,7.35,0,0,0-5.81-5.12,11.11,11.11,0,0,0-7.8,1.75,24,24,0,0,0-5.9,5.61,58.59,58.59,0,0,0-12.34,41.84,8.76,8.76,0,0,0,1.54,4.81,4.81,4.81,0,0,0,5,1.51c4.53-1.34,3.93-7.45,4.67-11a50,50,0,0,1,10-21.27Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.47,288.13a.39.39,0,0,0,.32-.37c.32-7.26,2.68-32,19.76-46.11a.38.38,0,0,0,.05-.55A.4.4,0,0,0,457,241c-17.33,14.27-19.72,39.34-20,46.69a.4.4,0,0,0,.38.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,288.92a12.12,12.12,0,0,0,5.54,7.69,15.58,15.58,0,0,0,8.39,1.4,36.33,36.33,0,0,0,8.52-2c1.37-.46,2.89-1.08,3-2.78a3,3,0,0,0-1-2.39,10.92,10.92,0,0,0-.88-.76.87.87,0,0,1,.47-1.57,21.91,21.91,0,0,0,2.42-.3,10.62,10.62,0,0,0,5.1-2.31A8.38,8.38,0,0,0,469,282.4a3.28,3.28,0,0,0-.33-3.43,3.85,3.85,0,0,0-1.89-.82q-.92-.19-1.83-.33a.81.81,0,0,1-.18-1.55l2.57-1.08a4.73,4.73,0,0,0,2-1.21,4.25,4.25,0,0,0,.49-3.55c-.31-1.61-.87-3.17-1.25-4.76a10.22,10.22,0,0,1-.17-4.88,41,41,0,0,0-14.43,1,10.35,10.35,0,0,0-3.94,1.73c-1.6,1.28-2,3.21-1.85,5.3a.37.37,0,0,1-.7.2l-1.65-3a2,2,0,0,0-2.56-.82,11.89,11.89,0,0,0-3.76,3,6.56,6.56,0,0,0-1.61,4.82A41.29,41.29,0,0,0,439,280a.66.66,0,0,1-1,.7l-.07-.06a2.21,2.21,0,0,0-1.56-.45c-1.45.18-1.82,1.65-1.92,2.91A24,24,0,0,0,435,288.92Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,288.92a12.12,12.12,0,0,0,5.54,7.69,15.58,15.58,0,0,0,8.39,1.4,36.33,36.33,0,0,0,8.52-2c1.37-.46,2.89-1.08,3-2.78a3,3,0,0,0-1-2.39,10.92,10.92,0,0,0-.88-.76.87.87,0,0,1,.47-1.57,21.91,21.91,0,0,0,2.42-.3,10.62,10.62,0,0,0,5.1-2.31A8.38,8.38,0,0,0,469,282.4a3.28,3.28,0,0,0-.33-3.43,3.85,3.85,0,0,0-1.89-.82q-.92-.19-1.83-.33a.81.81,0,0,1-.18-1.55l2.57-1.08a4.73,4.73,0,0,0,2-1.21,4.25,4.25,0,0,0,.49-3.55c-.31-1.61-.87-3.17-1.25-4.76a10.22,10.22,0,0,1-.17-4.88,41,41,0,0,0-14.43,1,10.35,10.35,0,0,0-3.94,1.73c-1.6,1.28-2,3.21-1.85,5.3a.37.37,0,0,1-.7.2l-1.65-3a2,2,0,0,0-2.56-.82,11.89,11.89,0,0,0-3.76,3,6.56,6.56,0,0,0-1.61,4.82A41.29,41.29,0,0,0,439,280a.66.66,0,0,1-1,.7l-.07-.06a2.21,2.21,0,0,0-1.56-.45c-1.45.18-1.82,1.65-1.92,2.91A24,24,0,0,0,435,288.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,288.92a12.12,12.12,0,0,0,5.54,7.69,15.58,15.58,0,0,0,8.39,1.4,36.33,36.33,0,0,0,8.52-2c1.37-.46,2.89-1.08,3-2.78a3,3,0,0,0-1-2.39,10.92,10.92,0,0,0-.88-.76.87.87,0,0,1,.47-1.57,21.91,21.91,0,0,0,2.42-.3,10.62,10.62,0,0,0,5.1-2.31A8.38,8.38,0,0,0,469,282.4a3.28,3.28,0,0,0-.33-3.43,3.85,3.85,0,0,0-1.89-.82q-.92-.19-1.83-.33a.81.81,0,0,1-.18-1.55l2.57-1.08a4.73,4.73,0,0,0,2-1.21,4.25,4.25,0,0,0,.49-3.55c-.31-1.61-.87-3.17-1.25-4.76a10.22,10.22,0,0,1-.17-4.88,41,41,0,0,0-14.43,1,10.35,10.35,0,0,0-3.94,1.73c-1.6,1.28-2,3.21-1.85,5.3a.37.37,0,0,1-.7.2l-1.65-3a2,2,0,0,0-2.56-.82,11.89,11.89,0,0,0-3.76,3,6.56,6.56,0,0,0-1.61,4.82A41.29,41.29,0,0,0,439,280a.66.66,0,0,1-1,.7l-.07-.06a2.21,2.21,0,0,0-1.56-.45c-1.45.18-1.82,1.65-1.92,2.91A24,24,0,0,0,435,288.92Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.63,296.21A58,58,0,0,1,446.51,285a.37.37,0,0,1,.14-.29c.09-.2.17-.39.27-.59a36.6,36.6,0,0,0-3.85-12.88.4.4,0,0,1,.15-.54.4.4,0,0,1,.54.15,36.94,36.94,0,0,1,3.79,12c3.28-6.59,8.52-14.29,16.61-19.92a.39.39,0,0,1,.55.09.41.41,0,0,1-.09.56c-8.35,5.8-13.61,13.85-16.81,20.53a24.23,24.23,0,0,1,13.75-1.86.39.39,0,0,1,.31.46.39.39,0,0,1-.46.32c-.07,0-7.63-1.39-14.15,2.26a57.69,57.69,0,0,0-3.86,11.14.39.39,0,0,1-.31.32h-.15A.4.4,0,0,1,442.63,296.21Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233,309.8l-26.06,14.91a24.69,24.69,0,0,1-24.61,0L163,313.53a7.41,7.41,0,0,1-3.71-6.41l0-13.2-4,2.34v11.46a8.64,8.64,0,0,0,4.33,7.49l23,13.24a24.34,24.34,0,0,0,24.23,0l26.25-15a9.85,9.85,0,0,0,4.79-10.42A9.76,9.76,0,0,1,233,309.8Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,309.8l-26.06,14.91a24.69,24.69,0,0,1-24.61,0L163,313.53a7.41,7.41,0,0,1-3.71-6.41l0-13.2-4,2.34v11.46a8.64,8.64,0,0,0,4.33,7.49l23,13.24a24.34,24.34,0,0,0,24.23,0l26.25-15a9.85,9.85,0,0,0,4.79-10.42A9.76,9.76,0,0,1,233,309.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,313.53l19.34,11.14a24.69,24.69,0,0,0,24.61,0L233,309.8a9.76,9.76,0,0,0,4.79-6.75,9.73,9.73,0,0,0-4.62-6.64l-21.38-12.82a8.67,8.67,0,0,1-4.2-7.42V266l-48.33,27.94,0,13.2A7.41,7.41,0,0,0,163,313.53Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,313.53a7.41,7.41,0,0,1-3.71-6.41l0-13.2-4,2.34v11.46a8.64,8.64,0,0,0,4.33,7.49l8.14,4.7v-3.67Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,313.53l4.71,2.71h0l50.46-28.83-6.37-3.82a8.67,8.67,0,0,1-4.2-7.42V266l-48.33,27.94,0,13.2A7.41,7.41,0,0,0,163,313.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.54,346.37h0l-.05,0Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.25,341.55l-.37-165.29a16.3,16.3,0,0,1,7.37-12.78L287.72,45.16c2-1.17,3.87-1.29,5.21-.54l-7.74-4.48h0c-1.35-.86-3.26-.79-5.37.43L74.36,158.9A16.26,16.26,0,0,0,67,171.67L67.35,337c0,2.21.76,3.79,2,4.61h0l.41.23,7.63,4.45C76.07,345.49,75.26,343.86,75.25,341.55Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,40.14h0c-1.35-.86-3.26-.79-5.37.43L74.36,158.9a15.45,15.45,0,0,0-5.65,6.3l7.9,4.57a15.54,15.54,0,0,1,5.64-6.29L287.72,45.16c2-1.17,3.87-1.29,5.21-.54Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,171.67,67.35,337c0,2.21.76,3.79,2,4.61h0l.41.23,7.63,4.45c-1.3-.78-2.11-2.41-2.12-4.72l-.37-165.29a14.53,14.53,0,0,1,1.73-6.49l-7.9-4.57A14.61,14.61,0,0,0,67,171.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,44.67l0,0,0,0Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.14,49.39c0-2.31-.82-3.93-2.12-4.71l0,0-.05,0c-1.34-.75-3.18-.63-5.21.54L82.25,163.48a16.3,16.3,0,0,0-7.37,12.78l.37,165.29c0,2.31.82,3.94,2.12,4.72l.12.06.05,0c1.34.7,3.14.57,5.13-.58L288.14,227.46a16.28,16.28,0,0,0,7.37-12.77ZM284.49,221.14,82.54,337.43l-.36-161.19a9.17,9.17,0,0,1,3.72-6.43l202-116.29.36,161.19A9.21,9.21,0,0,1,284.49,221.14Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.85,53.52l-5.23,3L283,212.16a9.21,9.21,0,0,1-3.72,6.43L82.53,331.86v5.57l202-116.29a9.21,9.21,0,0,0,3.72-6.43Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.85,53.52l-5.23,3L283,212.16a9.21,9.21,0,0,1-3.72,6.43L82.53,331.86v5.57l202-116.29a9.21,9.21,0,0,0,3.72-6.43Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,212.16l-.35-155.63L85.9,169.81a9.17,9.17,0,0,0-3.72,6.43l.35,155.62L279.25,218.59A9.21,9.21,0,0,0,283,212.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.38,349.9,106,193.67a15.38,15.38,0,0,1,7-12.07L307.2,69.77c1.92-1.11,3.66-1.22,4.93-.51L304.82,65h0c-1.28-.81-3.08-.74-5.08.41L105.54,177.27a15.35,15.35,0,0,0-7,12.07l.35,156.23c0,2.1.71,3.59,1.86,4.36h0a2.46,2.46,0,0,0,.39.22l7.21,4.2C107.16,353.62,106.39,352.09,106.38,349.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.82,65h0c-1.28-.81-3.08-.74-5.08.41L105.54,177.27a14.64,14.64,0,0,0-5.34,5.95l7.47,4.32A14.72,14.72,0,0,1,113,181.6L307.2,69.77c1.92-1.11,3.66-1.22,4.93-.51Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.57,189.34l.35,156.23c0,2.1.71,3.59,1.86,4.36h0a2.46,2.46,0,0,0,.39.22l7.21,4.2c-1.23-.74-2-2.27-2-4.46L106,193.67a13.73,13.73,0,0,1,1.64-6.13l-7.47-4.32A13.67,13.67,0,0,0,98.57,189.34Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05,202.73l.33,147.17c0,2.19.78,3.72,2,4.46l.11.07,0,0c1.26.66,3,.54,4.85-.55L307.6,242.07a15.38,15.38,0,0,0,7-12.07l-.33-147.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,208.5,304.28,99.87,304.57,230a6,6,0,0,1-2,3.39L116.36,340.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05,202.73l.33,147.17c0,2.19.78,3.72,2,4.46l.11.07,0,0c1.26.66,3,.54,4.85-.55L307.6,242.07a15.38,15.38,0,0,0,7-12.07l-.33-147.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,92.37c1.8-1,3.27-.21,3.27,1.87a7.15,7.15,0,0,1-3.25,5.63L139.73,196.1c-1.79,1-3.26.21-3.27-1.86a7.16,7.16,0,0,1,3.25-5.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.18,92.37c1.8-1,3.27-.21,3.27,1.87a7.15,7.15,0,0,1-3.25,5.63L139.73,196.1c-1.79,1-3.26.21-3.27-1.86a7.16,7.16,0,0,1,3.25-5.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.26,204.41a.26.26,0,0,1,.22,0c.14.07.15.3,0,.52l-1,1.94,3.55-2.05c.18-.11.33,0,.33.19a.72.72,0,0,1-.33.56l-3.55,2.05,1.06.72c.13.08.12.32,0,.54a.7.7,0,0,1-.22.23.21.21,0,0,1-.24,0L113.47,208a.27.27,0,0,1-.07-.08.51.51,0,0,1,0-.13.59.59,0,0,1,0-.13.59.59,0,0,1,.06-.16l1.56-2.87A.61.61,0,0,1,115.26,204.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.22,199.24a.21.21,0,0,1,.25,0l1.56,1.05.07.08a.59.59,0,0,1,0,.13.78.78,0,0,1,0,.14l-.06.15-1.56,2.87a.68.68,0,0,1-.24.26.24.24,0,0,1-.23,0c-.13-.06-.14-.3,0-.52l1.06-1.94-3.55,2.05c-.18.11-.33,0-.33-.18a.7.7,0,0,1,.33-.57l3.55-2.05L124,200c-.12-.09-.11-.33,0-.55A.58.58,0,0,1,124.22,199.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,195.45a1.67,1.67,0,0,1,1.09-.26.76.76,0,0,1,.32-.52h0c.18-.1.32,0,.31.21l0,.84a.75.75,0,0,1-.32.54l-.71.45h0c-.17.1-.32,0-.32-.17a.67.67,0,0,1,.24-.52,1.21,1.21,0,0,0-.59.18,3,3,0,0,0-1.37,2.38c0,.87.62,1.22,1.38.78a3,3,0,0,0,1.21-1.52.67.67,0,0,1,.29-.36.23.23,0,0,1,.15,0c.16,0,.22.2.14.44a4.49,4.49,0,0,1-1.79,2.25c-1.12.64-2,.12-2-1.17A4.45,4.45,0,0,1,130.78,195.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.26,204.41a.26.26,0,0,1,.22,0c.14.07.15.3,0,.52l-1,1.94,3.55-2.05c.18-.11.33,0,.33.19a.72.72,0,0,1-.33.56l-3.55,2.05,1.06.72c.13.08.12.32,0,.54a.7.7,0,0,1-.22.23.21.21,0,0,1-.24,0L113.47,208a.27.27,0,0,1-.07-.08.51.51,0,0,1,0-.13.59.59,0,0,1,0-.13.59.59,0,0,1,.06-.16l1.56-2.87A.61.61,0,0,1,115.26,204.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.22,199.24a.21.21,0,0,1,.25,0l1.56,1.05.07.08a.59.59,0,0,1,0,.13.78.78,0,0,1,0,.14l-.06.15-1.56,2.87a.68.68,0,0,1-.24.26.24.24,0,0,1-.23,0c-.13-.06-.14-.3,0-.52l1.06-1.94-3.55,2.05c-.18.11-.33,0-.33-.18a.7.7,0,0,1,.33-.57l3.55-2.05L124,200c-.12-.09-.11-.33,0-.55A.58.58,0,0,1,124.22,199.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,195.45a1.67,1.67,0,0,1,1.09-.26.76.76,0,0,1,.32-.52h0c.18-.1.32,0,.31.21l0,.84a.75.75,0,0,1-.32.54l-.71.45h0c-.17.1-.32,0-.32-.17a.67.67,0,0,1,.24-.52,1.21,1.21,0,0,0-.59.18,3,3,0,0,0-1.37,2.38c0,.87.62,1.22,1.38.78a3,3,0,0,0,1.21-1.52.67.67,0,0,1,.29-.36.23.23,0,0,1,.15,0c.16,0,.22.2.14.44a4.49,4.49,0,0,1-1.79,2.25c-1.12.64-2,.12-2-1.17A4.45,4.45,0,0,1,130.78,195.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.22,73.76c0-2.18-.78-3.72-2-4.45l0,0-.05,0c-1.27-.71-3-.6-4.93.51L113,181.6a15.38,15.38,0,0,0-7,12.07l0,9.06L314.24,82.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.22,73.76c0-2.18-.78-3.72-2-4.45l0,0-.05,0c-1.27-.71-3-.6-4.93.51L113,181.6a15.38,15.38,0,0,0-7,12.07l0,9.06L314.24,82.58Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.28,187.93c1-.61,1.91-.12,1.91,1.09a4.16,4.16,0,0,1-1.9,3.29c-1.05.61-1.91.12-1.91-1.09A4.18,4.18,0,0,1,115.28,187.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.49,184.92c1.05-.6,1.91-.12,1.91,1.09a4.22,4.22,0,0,1-1.9,3.3c-1,.6-1.91.12-1.91-1.09A4.17,4.17,0,0,1,120.49,184.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,181.92c1-.61,1.9-.12,1.91,1.09a4.21,4.21,0,0,1-1.9,3.29c-1.06.61-1.91.12-1.92-1.09A4.19,4.19,0,0,1,125.7,181.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.28,187.93c1-.61,1.91-.12,1.91,1.09a4.16,4.16,0,0,1-1.9,3.29c-1.05.61-1.91.12-1.91-1.09A4.18,4.18,0,0,1,115.28,187.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.49,184.92c1.05-.6,1.91-.12,1.91,1.09a4.22,4.22,0,0,1-1.9,3.3c-1,.6-1.91.12-1.91-1.09A4.17,4.17,0,0,1,120.49,184.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,181.92c1-.61,1.9-.12,1.91,1.09a4.21,4.21,0,0,1-1.9,3.29c-1.06.61-1.91.12-1.92-1.09A4.19,4.19,0,0,1,125.7,181.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.42,164.57l-.12-53.25a2,2,0,0,0-3-1.73l-81.21,46.77a5,5,0,0,0-2.5,4.33V214a2,2,0,0,0,3,1.73l81.33-46.84A5,5,0,0,0,304.42,164.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05,162.72l-90.46,52.09a5,5,0,0,0-2.5,4.35l.12,53.24a2,2,0,0,0,3,1.73l90.33-52a5,5,0,0,0,2.51-4.33V164.45A2,2,0,0,0,209.05,162.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05,162.72l-90.46,52.09a5,5,0,0,0-2.5,4.35l.12,53.24a2,2,0,0,0,3,1.73l90.33-52a5,5,0,0,0,2.51-4.33V164.45A2,2,0,0,0,209.05,162.72Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.59,224.08V278.9a2,2,0,0,0,3,1.74l82-47.23a6,6,0,0,0,2-3.39l-.12-52.51a2,2,0,0,0-3-1.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.59,224.08V278.9a2,2,0,0,0,3,1.74l82-47.23a6,6,0,0,0,2-3.39l-.12-52.51a2,2,0,0,0-3-1.73Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.24,285.34l.11,51.87a2,2,0,0,0,3,1.72L209.54,287a5,5,0,0,0,2.51-4.34V230.73a2,2,0,0,0-3-1.74l-90.31,52A5,5,0,0,0,116.24,285.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.52,227.49l-9.67,7.28a24,24,0,0,0-9.5,17.4l-.89,12,53.22-30.65-2.89-4.28a13,13,0,0,0-13.65-5.41l-5.44,1.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.68,213.32a3.13,3.13,0,0,1,1.55-1.63,1.88,1.88,0,0,1,.47-.17,2.92,2.92,0,0,1,2.59.86,5.08,5.08,0,0,1,1.26,2.51,20.58,20.58,0,0,1,.31,2.83,34.94,34.94,0,0,0,.78,5,6.32,6.32,0,0,0,3.22,4.21l.11.06a19.5,19.5,0,0,0,7.53,2v2.86c2.07,2.82,2.65,8.22-2.82,6.61s-9-5.25-9-8.83c0-1.51-.08-3.45-.11-5.18-.05-2.34-.1-4.29-.1-4.29a3.06,3.06,0,0,1-2,1,2.63,2.63,0,0,1-1.05,0,3.93,3.93,0,0,1-2.33-2,7.25,7.25,0,0,1-.75-3A6.14,6.14,0,0,1,150.68,213.32Z",
    style: {
      fill: "#8c5c5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.45,203.44a6.78,6.78,0,0,1,4.31-2.28l22.46,2.08c2.59,5.5.53,9.12.53,9.12.35,8.38.64,13.7-3.05,15.46a17.23,17.23,0,0,1-8.2,1.14,19.5,19.5,0,0,1-7.53-2l-.12-.06a6.38,6.38,0,0,1-3.22-4.23,34.43,34.43,0,0,1-.77-4.95,20.58,20.58,0,0,0-.31-2.83,5.08,5.08,0,0,0-1.26-2.51,2.92,2.92,0,0,0-2.59-.86,1.88,1.88,0,0,0-.47.17C151.59,208,151.41,204.75,152.45,203.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.68,204.08a7.85,7.85,0,0,1-.29,4.71,32.24,32.24,0,0,0-1.43,4.57,7.38,7.38,0,0,0,.62,4.61,5.39,5.39,0,0,0,3.58,2.86c2.41.51,4.77-.89,7.19-1.36a10,10,0,0,1,6.76,1.19,1.17,1.17,0,0,0,1.77-.93c.29-4.82.28-12.37-.43-15.92Z",
    style: {
      fill: "#8c5c5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.07,199.72l2.79-1.94a5.9,5.9,0,0,1-1.07,5.5,8.87,8.87,0,0,1-4.92,2.9,18.74,18.74,0,0,1-5.79.26,42.43,42.43,0,0,1-8.36-1.53,6.71,6.71,0,0,1-3.28-1.72,4.35,4.35,0,0,1-.18-5.12,6.53,6.53,0,0,1,4.62-2.68,17.69,17.69,0,0,1,5.56.44,16.85,16.85,0,0,0,5.56.4,5.77,5.77,0,0,0,4.48-3C179.06,195.82,178.07,199.72,178.07,199.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.02 212.63 175.12 217.59 171.36 218.92 171.02 212.63",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.02 212.63 175.12 217.59 171.36 218.92 171.02 212.63",
    style: {
      fill: "#7d4b4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.92,221.38l3.16,1a2,2,0,0,1-2.13,1A1.76,1.76,0,0,1,167.92,221.38Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.92,221.38l3.16,1a2,2,0,0,1-2.13,1A1.76,1.76,0,0,1,167.92,221.38Z",
    style: {
      fill: "#7d4b4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,223.28a1.86,1.86,0,0,1-1,.06,1.6,1.6,0,0,1-1-1.43,1.81,1.81,0,0,1,2.07,1.37Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.45,213.72a1.12,1.12,0,1,0,1.06-1.19A1.12,1.12,0,0,0,165.45,213.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.86,212.85a1.14,1.14,0,0,0,1.19,1.06,1.13,1.13,0,0,0-.12-2.25A1.14,1.14,0,0,0,174.86,212.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.72,208.31l2.58,1.59a1.59,1.59,0,0,0-.58-1.73A1.91,1.91,0,0,0,175.72,208.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08,208.7l-2.39,1.85a1.6,1.6,0,0,1,.39-1.79A1.89,1.89,0,0,1,166.08,208.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.46,226.81a7.15,7.15,0,0,1-1.31-2.72,6.29,6.29,0,0,0,2.71,2.81l.11.06a19.5,19.5,0,0,0,7.53,2v1.93A18.66,18.66,0,0,1,164,230,10,10,0,0,1,159.46,226.81Z",
    style: {
      fill: "#7d4b4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.21,233.79l-10,7.56a15,15,0,0,0-6,11.23l-.81,16.07,48.83-28.12-7.16-7.05a11,11,0,0,0-10.15-2.88l-3.53.8Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.21,233.79l-10,7.56a15,15,0,0,0-6,11.23l-.81,16.07,48.83-28.12-7.16-7.05a11,11,0,0,0-10.15-2.88l-3.53.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,221.51a8.41,8.41,0,0,0,2.34-11.09,4.6,4.6,0,0,0,2.22-2.09,2.44,2.44,0,0,0-3.18-3.25,3.43,3.43,0,0,0-1.37-4,3.25,3.25,0,0,0-4,.74,2.18,2.18,0,0,0-1.49-2.15,4.46,4.46,0,0,0-2.79.17c-.9.31-1.75.76-2.65,1a20,20,0,0,1-4.76.61,9.61,9.61,0,0,0-4.6,1.23c-1.34.87-2.53,2.9-1.8,4.66a2.67,2.67,0,0,0-1.91-1,2.57,2.57,0,0,0-2,.84c1,.62,2,1.28,3,1.9a2.72,2.72,0,0,0-3.06,1.22,6.1,6.1,0,0,0-.53,3.23,42.89,42.89,0,0,0,2.21,12.34c.68,2.06,1.67,4.24,3.62,5.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.4,231.42l-.44,4.92a1.81,1.81,0,0,0,.28,1.08,2.79,2.79,0,0,1-.44,3.22,3.75,3.75,0,0,1-2.19.74,10.68,10.68,0,0,1-8.14-3.13,2.34,2.34,0,0,1-.64-1.69l.32-12.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.14,224.73l10.26,6.69-.39,4.36a16.2,16.2,0,0,1-6.67-2.78A9.14,9.14,0,0,1,258.14,224.73Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,211.37a44.07,44.07,0,0,1-1.1,17.07,13.67,13.67,0,0,1-1.36,3.5,5.69,5.69,0,0,1-2.76,2.46,8.78,8.78,0,0,1-4.58,0c-2.79-.49-5.64-1-8.06-2.47s-4.34-4.11-4.11-6.93a4.84,4.84,0,0,1-4.62.26,4.92,4.92,0,0,1-2.53-3.92,3.4,3.4,0,0,1,2.35-3.65,3.37,3.37,0,0,1,2.69.79,9.86,9.86,0,0,1,1.88,2.19,3.33,3.33,0,0,0,.94,1,1.13,1.13,0,0,0,1.29,0,1.73,1.73,0,0,0,.37-1.41l-.16-3.57a1.41,1.41,0,0,1,.79-1.33,3.5,3.5,0,0,0,1.6-1.84,7.49,7.49,0,0,0,.45-2.15.88.88,0,0,1,1.2-.75A26.38,26.38,0,0,0,279.58,211.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.72 220.03 274.94 225.44 271.11 226.16 271.72 220.03",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,228l2.91,1.42a1.9,1.9,0,0,1-2.2.62A1.71,1.71,0,0,1,267.41,228Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,228l2.91,1.42a1.9,1.9,0,0,1-2.2.62A1.71,1.71,0,0,1,267.41,228Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.13,230.16a1.72,1.72,0,0,1-1-.1,1.55,1.55,0,0,1-.78-1.53,1.85,1.85,0,0,1,1.15.4A1.82,1.82,0,0,1,269.13,230.16Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.18,220.25a1.1,1.1,0,1,0,1.2-1A1.1,1.1,0,0,0,266.18,220.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,220.82a1.1,1.1,0,1,0,1.21-1A1.1,1.1,0,0,0,275.4,220.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.9,216.57l2.26,1.92a1.56,1.56,0,0,0-.3-1.76A1.84,1.84,0,0,0,276.9,216.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.55,215.49l-2.6,1.44a1.57,1.57,0,0,1,.65-1.67A1.85,1.85,0,0,1,267.55,215.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,273.46c-.43,1-1.61,1.48-2.18,2.41a2.33,2.33,0,0,0,2.08,3.55,2.38,2.38,0,0,0,2-1.31,6.67,6.67,0,0,1,0,2.67,2.62,2.62,0,0,1-1.67,2,4.73,4.73,0,0,1-3,8c.34,2.43-1.24,5.06-3.25,6.48a10.52,10.52,0,0,1-7,1.64,22.78,22.78,0,0,1-7.05-2.07,25.33,25.33,0,0,1-10.71,1.6c-2.31-.22-4.72-.84-6.32-2.52s-2-4.67-.27-6.24a3.52,3.52,0,0,1-3.63,0,3.09,3.09,0,0,1,.54-5.68,2.7,2.7,0,0,1-1.24-2.44,2.54,2.54,0,0,1,1.72-2,2.21,2.21,0,0,0,.6,2.26,2,2,0,0,0,2.25.1,2.8,2.8,0,0,0,1.16-1.94,9.58,9.58,0,0,0,0-2.33,17.18,17.18,0,0,1,.77-7.94,8,8,0,0,1,5.75-5.14,13.22,13.22,0,0,1,15.44-8.83c2.67.59,5.26,2.18,6.33,4.69a14.71,14.71,0,0,1,3.5-.3,4.65,4.65,0,0,1,3.15,1.17,2.84,2.84,0,0,1,.69,3.15c-.35.72-1.09,1.37-.92,2.15s.92,1,1.29,1.58a2,2,0,0,1,0,1.87,6.67,6.67,0,0,1-1.12,1.58c-.39.45-.81,1-.59,1.59S185,274,185.35,273.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,300.69a4.82,4.82,0,0,1-3.14.84,17.67,17.67,0,0,1-14.06-7l3.12-.27V284.24l10.86,4.19v5.8h2.78a8,8,0,0,1,1.33,2.36A3.8,3.8,0,0,1,175,300.69Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,284.53c3.25,6.32,5.27,6.45,10.09,7v-3.12Z",
    style: {
      fill: "#d96e6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,269.94a39.6,39.6,0,0,1,.17,14.44c-.32,1.79-.84,3.7-2.26,4.84-1.75,1.41-4.26,1.2-6.49.92a26,26,0,0,1-7.15-1.61,8.75,8.75,0,0,1-5-5.06,3.16,3.16,0,0,1-3.81-.62,5.61,5.61,0,0,1-1.4-3.83,3.69,3.69,0,0,1,1.38-3.34,2.86,2.86,0,0,1,2.49-.1,6,6,0,0,1,2.08,1.5,4,4,0,0,0,1,.84,1.2,1.2,0,0,0,1.24,0,1.75,1.75,0,0,0,.53-1.46,13.57,13.57,0,0,1,1.46-6.36c1.12-1.89,3.38-3.26,5.5-2.69a13.26,13.26,0,0,0,2.86.93,4.56,4.56,0,0,0,2.26-.74l0,0A3.31,3.31,0,0,1,181.4,269.94Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.55 275.86 177.44 280.72 174 281.36 174.55 275.86",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.55 275.86 177.44 280.72 174 281.36 174.55 275.86",
    style: {
      fill: "#d96e6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.68,283l2.62,1.27a1.72,1.72,0,0,1-2,.56A1.53,1.53,0,0,1,170.68,283Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.68,283l2.62,1.27a1.72,1.72,0,0,1-2,.56A1.53,1.53,0,0,1,170.68,283Z",
    style: {
      fill: "#d96e6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.22,285a1.48,1.48,0,0,1-.91-.09,1.39,1.39,0,0,1-.7-1.37,1.57,1.57,0,0,1,1.61,1.46Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.22,285a1.48,1.48,0,0,1-.91-.09,1.39,1.39,0,0,1-.7-1.37,1.57,1.57,0,0,1,1.61,1.46Z",
    style: {
      fill: "#c75555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,276.05a1,1,0,1,0,1.08-.89A1,1,0,0,0,169.57,276.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.86,276.56a1,1,0,0,0,.88,1.09,1,1,0,0,0,1.09-.89,1,1,0,0,0-2-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.21,272.74l2,1.73a1.41,1.41,0,0,0-.27-1.59A1.71,1.71,0,0,0,179.21,272.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8,271.78l-2.34,1.28a1.42,1.42,0,0,1,.59-1.5A1.65,1.65,0,0,1,170.8,271.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.29,294.23l.87,10.84,7.35-4.24C184,296.9,181.55,294.23,177.29,294.23Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.29,294.23h-2.7a8,8,0,0,1,1.33,2.36,3.8,3.8,0,0,1-.89,4.1,4.82,4.82,0,0,1-3.14.84,17.67,17.67,0,0,1-14.06-7l-9.28.8s.21,19.56.16,22.38a18.84,18.84,0,0,0,.31,4.11l34.35-19.78A28.39,28.39,0,0,0,177.29,294.23Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.29,294.23h-2.7a8,8,0,0,1,1.33,2.36,3.8,3.8,0,0,1-.89,4.1,4.82,4.82,0,0,1-3.14.84,17.67,17.67,0,0,1-14.06-7l-9.28.8s.21,19.56.16,22.38a18.84,18.84,0,0,0,.31,4.11l34.35-19.78A28.39,28.39,0,0,0,177.29,294.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.55,295.36c-8.9,3-6.82,10.59-2.28,18.71,1.13,2,2.49,4.52,3.9,7.12l9.58-5.52C156.31,307.24,151.59,296.9,148.55,295.36Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.85,176.24a41.55,41.55,0,0,1,2.92,6l3.56-2-3.25-6.34a6,6,0,0,0-6.59-3.13l-1.13.24A20.66,20.66,0,0,1,275.85,176.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.44,186.59a4.75,4.75,0,0,0-2.67-2.71,4.59,4.59,0,0,0-3.92.67,7.29,7.29,0,0,0-1.21,1,15,15,0,0,0-2.24,7.88v10.32L253.13,197l-.84-6.61A14.43,14.43,0,0,0,251.44,186.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.85,176.24a20.66,20.66,0,0,0-4.49-5.27l-7.8,1.68-8,3.31-7.49,5a14.85,14.85,0,0,0-4.46,4.61,7.29,7.29,0,0,1,1.21-1,4.59,4.59,0,0,1,3.92-.67,4.75,4.75,0,0,1,2.67,2.71,14.43,14.43,0,0,1,.85,3.81l.84,6.61,25.64-14.77A41.55,41.55,0,0,0,275.85,176.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.85,176.24a41.55,41.55,0,0,1,2.92,6l3.56-2-3.25-6.34a6,6,0,0,0-6.59-3.13l-1.13.24A20.66,20.66,0,0,1,275.85,176.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.44,186.59a4.75,4.75,0,0,0-2.67-2.71,4.59,4.59,0,0,0-3.92.67,7.29,7.29,0,0,0-1.21,1,15,15,0,0,0-2.24,7.88v10.32L253.13,197l-.84-6.61A14.43,14.43,0,0,0,251.44,186.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.85,176.24a20.66,20.66,0,0,0-4.49-5.27l-7.8,1.68-8,3.31-7.49,5a14.85,14.85,0,0,0-4.46,4.61,7.29,7.29,0,0,1,1.21-1,4.59,4.59,0,0,1,3.92-.67,4.75,4.75,0,0,1,2.67,2.71,14.43,14.43,0,0,1,.85,3.81l.84,6.61,25.64-14.77A41.55,41.55,0,0,0,275.85,176.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.47,158.74a9.89,9.89,0,0,0,1.19-12.44,3.45,3.45,0,0,0,2.12-3.45,3.41,3.41,0,0,0-2.72-3,9.53,9.53,0,0,0-3.6.51,17.51,17.51,0,0,1-6.21,0c-2.06-.29-4.1-.74-6.17-.89a12.58,12.58,0,0,0-6.11.87,6.81,6.81,0,0,0-3.95,4.54c-1.6-.43-3.5.59-4.53,1.89a8,8,0,0,0-1.49,4.65c-.06,1.65.17,3.3.25,5a11.37,11.37,0,0,1-.62,4.89c-.75,1.78-2.23,3.24-2.7,5.12a5.15,5.15,0,0,0,6.3,6.23,14,14,0,0,1-.48-4c.16,1.82,2,3.24,3.7,3.85a14.29,14.29,0,0,0,5.42.48l6.42-.25,7.49-.3a10.13,10.13,0,0,0,3.91-.67,6.7,6.7,0,0,0,3.49-5.75A17.55,17.55,0,0,0,275.47,158.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.3,169.17V176s5.59,3.57,3.23,5.46c-4.43,3.56-13.94-5.5-13.94-5.5V164.59Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.59,164.59c1.65,4.9,7.64,8.61,10.71,9.35v-4.77Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.87,156.83a10.08,10.08,0,0,1,.12,2.57,3,3,0,0,1-.85,1.72,1.92,1.92,0,0,1-1.73.51,3.36,3.36,0,0,0-6.52-1.59,4.21,4.21,0,0,0,.7,3.49,8,8,0,0,0,2.81,2.34,2.84,2.84,0,0,0,3.38-1.33c3.27,4.14,9,7.24,14.29,6.8a7.73,7.73,0,0,0,4.06-1.44c2-1.56,2.16-3.91,2.42-6.24a32.94,32.94,0,0,0-.07-8.87,17.46,17.46,0,0,0-5.6-10.67C268.05,152.93,260,156.18,256.87,156.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.98 155.82 271.63 160.32 268.23 161.49 267.98 155.82",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12,163.68l2.84.9a1.75,1.75,0,0,1-1.93.87A1.57,1.57,0,0,1,265.12,163.68Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12,163.68l2.84.9a1.75,1.75,0,0,1-1.93.87A1.57,1.57,0,0,1,265.12,163.68Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,165.4a1.57,1.57,0,0,1-.93,0,1.4,1.4,0,0,1-.91-1.29,1.6,1.6,0,0,1,1.09.21A1.64,1.64,0,0,1,267,165.4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,156.76a1,1,0,1,0,1-1.06A1,1,0,0,0,263,156.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.44,156.05a1,1,0,1,0,1-1.06A1,1,0,0,0,271.44,156.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.24,152l2.31,1.45a1.42,1.42,0,0,0-.51-1.56A1.7,1.7,0,0,0,272.24,152Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.56,152.24l-2.17,1.66a1.43,1.43,0,0,1,.36-1.61A1.71,1.71,0,0,1,263.56,152.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.63,159.78Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.92,158.75a4.48,4.48,0,0,1,1.69-1.71l36.83-20.89c2-1.16,6.83.41,6.83,3.68v26.48a4.52,4.52,0,0,1-2.28,3.93L361.84,180l2.37-1.35-1.49,4.2a.23.23,0,0,1-.3.15v0c-.26-.14-1.42-.76-2.09-1.2h0l0,0h0l-.06-.06-.36-.59-17.7,9.9a4.47,4.47,0,0,1-6.83-3.67V161A4.53,4.53,0,0,1,335.92,158.75Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.22,181.76l.06.06h0l0,0h0c.67.44,1.83,1.06,2.09,1.2v0a.22.22,0,0,1-.15-.1l-1.43-2.33.28-.16h0l-1.26.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.42,161.3a4.68,4.68,0,0,1,1.21-1.52h0a4.07,4.07,0,0,1,.55-.37L379,138.52a1.51,1.51,0,0,1,2.26,1.31c0-3.27-4.8-4.84-6.83-3.68L337.61,157a4.48,4.48,0,0,0-1.69,1.71Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.91,189.76V163.33a4.89,4.89,0,0,1,0-.54,4.64,4.64,0,0,1,.48-1.49l-4.5-2.55a4.53,4.53,0,0,0-.59,2.21V187.4a4.47,4.47,0,0,0,6.83,3.67A1.5,1.5,0,0,1,339.91,189.76Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.26 158.99 361.3 171.24 358.28 172.98 358.27 168.2 354.15 170.58 354.17 175.36 351.16 177.09 351.13 164.84 354.13 163.11 354.15 167.7 358.26 165.33 358.25 160.73 361.26 158.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.72,158.72c-1.06.61-1.77.25-1.78-.75a3.53,3.53,0,0,1,1.77-2.8c1.06-.61,1.77-.3,1.77.7A3.49,3.49,0,0,1,364.72,158.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.3 170.09 363.27 160.61 366.17 158.93 366.2 168.41 363.3 170.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.57 161.41 368.27 162.75 367.68 155.28 371.12 153.3 370.57 161.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.42,163.07c1-.6,1.73-.24,1.73.8a3.51,3.51,0,0,1-1.72,2.83c-1,.59-1.72.17-1.73-.84A3.46,3.46,0,0,1,369.42,163.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.35,270.6,377,283.52,371,293.69l6.72,10.63,10.15-15.75a8.87,8.87,0,0,0,1-7.27,122.93,122.93,0,0,0-6.6-17.94Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.77,267.31l-5.42,3.29,5.08,9.81.3-11.55C375.75,268.35,375.76,267.83,375.77,267.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,245.63c7.7-1.43,12.1,1.14,18.61,18.55-2.66,6-13.93,8.16-13.93,8.16Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.91,259.53c-1.54-4.74-5.44-8.19-9.42-11.29l4.22,24.1a36.58,36.58,0,0,0,6-1.85c0-.54,0-1.09,0-1.63C375.82,265.73,375.89,262.52,374.91,259.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.17,428.1c-.63,1.32-2.63,2.54-4.81,2.9a22.26,22.26,0,0,1-6.6-.42,43.27,43.27,0,0,0-9.85-.25,50.38,50.38,0,0,1-6.13.43,9.67,9.67,0,0,1-5.76-1.82,5.85,5.85,0,0,1-2.16-3.68,5.55,5.55,0,0,0,2.16,5,9.75,9.75,0,0,0,5.76,1.83,52.48,52.48,0,0,0,6.13-.44,43.85,43.85,0,0,1,9.85.25c2.19.31,4.57.93,6.75.57s4.18-1.58,4.81-2.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.26,424.2c1.84,0,1.16-2.72,2.91-4.54-.71,0-1.43,0-2.14,0C328.46,422,328,424.2,329.26,424.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.08,424.06c1.85,0,1.36-3.24,3.18-5.13q-.63.21-1.26.36c-.36.08-.73.14-1.09.19C332.29,421.78,331.82,424.06,333.08,424.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.27,417.84a2.5,2.5,0,0,0-1-1.49l-9.93-.25a8.64,8.64,0,0,1-4.12,2.83c-1.82,1.89-1.33,5.13-3.18,5.13-1.26,0-.79-2.28.83-4.58-.58.09-1.16.14-1.74.18-1.75,1.82-1.07,4.54-2.91,4.54-1.24,0-.8-2.23.77-4.49h-1.39c-.42,0-.85,0-1.27-.07-3.65,2.88-4,6-3.49,10.94a13.44,13.44,0,0,0,1.9.19,50.38,50.38,0,0,0,6.13-.43,43.27,43.27,0,0,1,9.85.25,22.26,22.26,0,0,0,6.6.42c2.18-.36,4.18-1.58,4.81-2.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.37,419.63a15.35,15.35,0,0,0-5,0,5.93,5.93,0,0,0-4.47,3.88,4.31,4.31,0,0,0-.07,1.75,5.85,5.85,0,0,0,2.16,3.68,8.53,8.53,0,0,0,3.86,1.63C323.4,425.65,323.72,422.51,327.37,419.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.1,413.27v4.78a2,2,0,0,0,2,2h5a3.22,3.22,0,0,0,3.22-3.12l.12-3.63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.19,411.14a3.67,3.67,0,0,1-3,2.11,6.38,6.38,0,0,1-3.81-.94c-1.73-1.09-2.4-2.81-3.57-4.36a25.78,25.78,0,0,0-4.16-4.06,13.73,13.73,0,0,1-4-4.6,5.82,5.82,0,0,1-.47-1.69,5.92,5.92,0,0,0,.47,3.24,13.73,13.73,0,0,0,4,4.6,26.2,26.2,0,0,1,4.16,4.06c1.17,1.55,1.84,3.27,3.57,4.36a6.31,6.31,0,0,0,3.81.94,3.67,3.67,0,0,0,3-2.11,8.22,8.22,0,0,0,.19-2.67A3.29,3.29,0,0,1,373.19,411.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.91,400.64a1.24,1.24,0,0,0-.24.82.83.83,0,0,0,.54.61,1.2,1.2,0,0,0,1.12-.29,6.26,6.26,0,0,0,.77-.92,5.86,5.86,0,0,1,2.56-1.86,5.66,5.66,0,0,1,1.53-.34l-1.25-1.13a6.3,6.3,0,0,0-2.26.55A6.24,6.24,0,0,0,361.91,400.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.17,396.69a6.25,6.25,0,0,0-2.76,2.55,1.21,1.21,0,0,0-.25.82.88.88,0,0,0,.55.62,1.18,1.18,0,0,0,1.11-.29,6.22,6.22,0,0,0,.78-.92,5.85,5.85,0,0,1,2.55-1.87,6,6,0,0,1,2.51-.33l-1.23-1.12A6.31,6.31,0,0,0,362.17,396.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.65,395.45a12.83,12.83,0,0,0-3.9-2.61,5.17,5.17,0,0,0-5.36.74,4.66,4.66,0,0,0-1.18,4,5.82,5.82,0,0,0,.47,1.69,8.44,8.44,0,0,0,1.23,1.95C356.38,397,360.1,395,364.65,395.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.29,406.94a8.93,8.93,0,0,0-1-4.18l-2.41-2.53-1.72-1.57a5.66,5.66,0,0,0-1.53.34,5.86,5.86,0,0,0-2.56,1.86,6.26,6.26,0,0,1-.77.92,1.2,1.2,0,0,1-1.12.29.83.83,0,0,1-.54-.61,1.24,1.24,0,0,1,.24-.82,6.24,6.24,0,0,1,2.77-2.56,6.3,6.3,0,0,1,2.26-.55l-.28-.26a6,6,0,0,0-2.51.33,5.85,5.85,0,0,0-2.55,1.87,6.22,6.22,0,0,1-.78.92,1.18,1.18,0,0,1-1.11.29.88.88,0,0,1-.55-.62,1.21,1.21,0,0,1,.25-.82,6.25,6.25,0,0,1,2.76-2.55,6.31,6.31,0,0,1,3.26-.54l0,0-.74-.66c-4.55-.49-8.27,1.51-8.74,5.79a20.73,20.73,0,0,0,2.73,2.65A25.78,25.78,0,0,1,362.8,408c1.17,1.55,1.84,3.27,3.57,4.36a6.38,6.38,0,0,0,3.81.94,3.67,3.67,0,0,0,3-2.11,3.29,3.29,0,0,0,.19-1.12A28.06,28.06,0,0,0,373.29,406.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.58,399.38l.28,5.14c3.24,1.86,6.65.85,7.79-.34l.21-4.8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,288.38a4.72,4.72,0,0,1-.49-1.77l-.27-4.41-31.41,2c-.41,2.2-.83,4.9-1.25,8A46.71,46.71,0,0,0,371,288.38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.62,247.68l-8.41,1.65c-1.85,3.4-3.75,6.59-5.61,10-1.39,2.56-2.83,5.28-2.73,8.2a8.41,8.41,0,0,0,3.31,6.25,3.69,3.69,0,0,1,1.53,3.25l-.77,9.22c13.19,4,29.32.49,32.87-2.57,1-4.81,2-9.92,3-14.73,1.11-5.13,2.23-10.31.63-15.67a10.58,10.58,0,0,0-1.26-2.73h0a10.48,10.48,0,0,0-10.53-4.77Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.82,258.93l-.21.39c-1.4,2.56-2.84,5.28-2.74,8.2a8.41,8.41,0,0,0,3.31,6.25,3.69,3.69,0,0,1,1.53,3.25l-.26,3.08c2.64-5.18,6.19-12.71,7.69-18.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.45,289.18a5,5,0,0,1-.49-.8,46.71,46.71,0,0,1-33.42,3.8c-2.36,17.62-4.4,47.45-3.15,67.13,1,22.92,5.26,55.36,5.26,55.36,5.5,1.65,9.62.64,11.18-.55,1.83-22.73,5.86-38.31,2.75-53.34,2.07-10.51,3.42-23.71,3.42-23.71l1.59,23.22L364,401.11a9.67,9.67,0,0,0,9.66-.49c3.91-23.34,5.38-39.16,1.95-50.74C380.79,311.58,381.06,301.78,371.45,289.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.31,332.48l2.88-12.09c3.36-.55,8.62-2.75,11.38-7.36A23.15,23.15,0,0,1,359.63,318L357,337.07l.56,8.18.22-3A63.49,63.49,0,0,1,359.31,332.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.38,225.09a14.64,14.64,0,0,1-1.65-7.74,8.38,8.38,0,0,1,4.06-6.54,5.92,5.92,0,0,1,7.27,1.27A13.49,13.49,0,0,1,370,225c-.18,2.78-1.2,5.52-.88,8.29.18,1.63.82,3.28.4,4.86a5,5,0,0,1-2.65,3c-1.21.64-4.05.47-5.39.75-4.1,3.72-9.24,2.33-12.52-1S340.38,225.09,340.38,225.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.53 228.79 336.97 233.24 339.77 234.27 339.53 228.79",
    style: {
      fill: "#ff9192"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.24,226.81c.41-3.91,1.55-7.58,4.09-9.45a21.05,21.05,0,0,0,2.93,14,6.11,6.11,0,0,1,1.89-3.34,3.51,3.51,0,0,1,3.63-.78,3.55,3.55,0,0,1,1.83,2,4.74,4.74,0,0,1-5.92,6.26,9.12,9.12,0,0,0,7,7.09,11.7,11.7,0,0,0,6.78-.65l1.06,5.26c-4.28,4.56-11.6,1.5-11.6,1.5l-1-5.18c-8.42.5-9.21.36-10.13-4.28A45.33,45.33,0,0,1,339.24,226.81Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.88,221.14a14.83,14.83,0,0,1,6.7-8A14.11,14.11,0,0,1,370,225c-.18,2.78-1.2,5.52-.88,8.29.18,1.63.82,3.28.4,4.86a5,5,0,0,1-2.65,3c-1.21.64-4.05.47-5.39.75-.18.16-.36.3-.54.44a40.64,40.64,0,0,1-3.33-8.55A21.93,21.93,0,0,1,357.88,221.14Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.22,218.22a10.72,10.72,0,0,1,20.45-.25c2.54,7.68-4,15.86-2.54,23.83.51,2.87,2,5.48,2.55,8.35A12.37,12.37,0,0,1,370,264.65c1.83-2,1.86-5.13.82-7.64s-2.9-4.58-4.5-6.78C359.86,241.36,357,228.72,360.22,218.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.21,249.33c-9,1.82-18.07,24.79-18.07,24.79l-8.57-24,1.84-9a2.92,2.92,0,0,0-.12-1.55l-2-5.59a1.18,1.18,0,0,0-1.37-.75h0a1.19,1.19,0,0,0-.88,1.49l1.53,5.13-2.43-4.61a1.59,1.59,0,0,0-2.18-.65L308,235.65a1.58,1.58,0,0,0-.63,2.13l2.12,4c-2.4,6.88-.25,8.89-.25,8.89l4.06,25.51a11.69,11.69,0,0,0,9.61,9.69h0a11.69,11.69,0,0,0,11.76-5.21C347.92,260.15,355.27,247,342.21,249.33Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.78,279a25.21,25.21,0,0,1,1.36-4.83l-1-2.92A8.41,8.41,0,0,0,322.78,279Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.21,249.33c-4,1.1-8.34,3.19-14.52,15.32.69,8.75,13.6,6.55,13.6,6.55,3.41-6.5,7.08-13.28,7.8-16.46C350.3,249.43,347.88,248.2,342.21,249.33Z",
    style: {
      fill: "#8700A9"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardvaloresprotagonismo);
export default __webpack_public_path__ + "static/media/card.valores.protagonismo.bf5225556119ed6d17214e97f4496af6.svg";
export { ForwardRef as ReactComponent };